import React from "react";
import BillingCancelledPage from "../components/BillingCancelledPage/BillingCancelledPage";
import { BusinessPlan } from "../../enums/business-plan";
import { useHistory } from "react-router";

const BillingCancelledView: React.FC = () => {
  const history = useHistory();
  return (
    <BillingCancelledPage
      plan={BusinessPlan.ESSENTIALS_ANNUAL}
      onRetry={() => history.push("/select-billing-account")}
    />
  );
};

export default BillingCancelledView;
